import React, { useContext } from "react";
import { Button } from "@pushpress/shared-components";
import { GetStartedEvent } from "../events";
import { useAnalytics } from "../../../components/providers/AnalyticsProvider";
import { cn } from "../../../utils/css";
import { AppContext } from "../../../context/app";

function InsuranceMessage() {
  const { trackEvent } = useAnalytics();
  const { client } = useContext(AppContext);

  return (
    <div
      className={cn(
        "tw-flex tw-flex-col tw-justify-between tw-p-5 tw-bg-primary tw-rounded-xl",
        "tw-text-white tw-max-w-[1200px] tw-w-full tw-overflow-hidden tw-flex-1",
        "tw-bg-gradient-to-br tw-from-primary tw-to-blue-400",
      )}
    >
      <h2 className={"tw-text-xl tw-font-semibold"}>
        Protect your gym with affordable and tailored insurance - Save up to
        39%!
      </h2>
      <div className={"tw-grow tw-my-3 tw-flex tw-flex-col tw-justify-start"}>
        <p className="">Fast claim payouts and free cancellation at any time</p>
      </div>
      <Button
        style={{
          backgroundColor: "white",
          color: "hsl(217, 100%, 50%)",
          fontWeight: "500",
        }}
        fullWidth
        buttonType="text"
        target="_blank"
        text="Get a quote in under 5 minutes"
        onClick={() => {
          trackEvent(GetStartedEvent.InsuranceMessageClicked);
          window.open(
            `https://insurance.pushpress.com?partner_customer_id=${client.externalUuid}&utm_source=pushpress&utm_medium=core&utm_campaign=gs-insurance-banner`,
            "_blank",
          );
        }}
      />
    </div>
  );
}

export default InsuranceMessage;
